module.exports = __webpack_public_path__ + "static/media/Adecco.bac8e980.png";